// Vendor imports
const qs = require('qs')
const { createSelector } = require('reselect')

function createQueryParamsSelector() {
  return createSelector(
    state => state.router.location.search,
    search => qs.parse(search, { ignoreQueryPrefix: true })
  )
}

module.exports = {
  createQueryParamsSelector
}
